import { Injectable } from '@angular/core';

import { ToastContext } from '@anjuna/core';

export class MockToast {
    constructor(public message: string, public context: ToastContext, public header?: string) {}

    public dismiss(): Promise<void> {
        return new Promise<void>((resolve) => resolve());
    }
}

/** @dynamic */
export const mockToastController = {
    dismissAll: () => {},
    error: (message: string, header?: string) => {
        return new MockToast(message, 'danger', header) as HTMLAnjToastElement;
    },
    message: (message: string, header?: string) => {
        return new MockToast(message, 'info', header) as HTMLAnjToastElement;
    },
    success: (message: string, header?: string) => {
        return new MockToast(message, 'success', header) as HTMLAnjToastElement;
    },
    warn: (message: string, header?: string) => {
        return new MockToast(message, 'success', header) as HTMLAnjToastElement;
    },
    componentOnReady: () => {
        return new Promise(r => r(this));
    },
    addEventListener: (name, fn) => {}
};

/** @dynamic */
@Injectable()
export class MockToastService {
    private readonly controller: HTMLAnjToastControllerElement;

    public static createController(): HTMLAnjToastControllerElement {
        return mockToastController as any;
    }

    constructor() {
        this.controller = MockToastService.createController();
    }

    public dismissAll(): void {
        this.controller.dismissAll();
    }

    public error(message: string, header?: string): Promise<HTMLAnjToastElement> {
        return this.controller.error(message, header);
    }

    public message(message: string, header?: string): Promise<HTMLAnjToastElement> {
        return this.controller.message(message, header);
    }

    public success(message: string, header?: string): Promise<HTMLAnjToastElement> {
        return this.controller.success(message, header);
    }

    public warn(message: string, header?: string): Promise<HTMLAnjToastElement> {
        return this.controller.warn(message, header);
    }
}
